module.exports = __webpack_public_path__ + "static/media/vector4.2184ed3a.png";